import React from 'react';
import PropTypes from 'prop-types';
import { getReasonAdditionalReviewSectionData } from './configStructure'

import './ReasonAdditionalReviewSection.scss'

const ReasonAdditionalReviewSection = (props) => {
    let formattedFields = props.fields;
    const reviewSectionData = getReasonAdditionalReviewSectionData();
        return <div className = "reason-additional-review-section-card" >
            <div className = "section-header">
                <span className = "section-header-title" >{ props.sectionName }</span>
                <span className="scope-divider"></span>
                <span className = "section-header-scope" >{ props.sectionScope }</span> 
            </div>

            <div className="section-footer">
            {<span className="section-footer-title">{reviewSectionData.reasonAdditionalData[0].name}</span> }
            {!formattedFields.ReasonForAdditionalReview && (props.fields.ReasonForAdditionalReview === undefined ? 
            <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value">{props.fields.ReasonForAdditionalReview}</span>)}
            {formattedFields.ReasonForAdditionalReview && formattedFields.ReasonForAdditionalReview === undefined ? 
            <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value">{formattedFields.ReasonForAdditionalReview}</span>}
        </div>
        </div>

}

ReasonAdditionalReviewSection.propTypes = {
    fields: PropTypes.object,
    sectionName: PropTypes.string,
    sectionScope: PropTypes.string

};

ReasonAdditionalReviewSection.defaultProps = {
    sectionScope : '',
    sectionName : '',
    fields : {},
};

export default (ReasonAdditionalReviewSection);